"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _roundToDecimal = _interopRequireDefault(require("./roundToDecimal"));

/**
 * Round number to six decimal places
 * In our application, we are using six decimal places as default
 */
var roundForPrecision = function roundForPrecision(n) {
  var decimal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
  return (0, _roundToDecimal["default"])(n, decimal);
};

var _default = roundForPrecision;
exports["default"] = _default;